(function () {
  'use strict';
  function setup() {
    const hero = document.querySelector('.hero');
    if (!hero || hero.dataset.interactive) return;
    hero.dataset.interactive = 'true';
    const chrome = document.querySelector('[data-site-chrome]');
    if (chrome) {
      let queued = false;
      const compact = function () {
        queued = false;
        const wasCompact = chrome.dataset.compact === 'true';
        chrome.dataset.compact = String(window.scrollY > (wasCompact ? 40 : 140));
      };
      window.addEventListener('scroll', function () {
        if (!queued) { queued = true; window.requestAnimationFrame(compact); }
      }, {passive:true});
      compact();
    }
    const gallery = document.querySelector('[data-nature-gallery]');
    if (gallery) {
      const arrows = document.querySelector('.gallery-arrows');
      const previous = document.querySelector('[data-gallery-prev]');
      const next = document.querySelector('[data-gallery-next]');
      const updateGallery = function () {
        if (!arrows) return;
        arrows.hidden = gallery.scrollWidth <= gallery.clientWidth + 2;
        previous.disabled = gallery.scrollLeft < 2;
        next.disabled = gallery.scrollLeft >= gallery.scrollWidth - gallery.clientWidth - 2;
      };
      const moveGallery = function (direction) {
        gallery.scrollBy({left:direction * gallery.clientWidth, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      if (previous) previous.addEventListener('click', function () {moveGallery(-1);});
      if (next) next.addEventListener('click', function () {moveGallery(1);});
      gallery.addEventListener('scroll', updateGallery, {passive:true});
      window.addEventListener('resize', updateGallery);
      updateGallery();
    }
    const motionButton = document.querySelector('[data-motion-toggle]');
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    let paused = media.matches;
    function renderMotion() {
      hero.dataset.motion = paused || media.matches ? 'paused' : 'running';
      if (motionButton) {
        motionButton.hidden = media.matches;
        motionButton.textContent = paused ? motionButton.dataset.playLabel : motionButton.dataset.pauseLabel;
      }
    }
    if (motionButton) motionButton.addEventListener('click', function () { paused = !paused; renderMotion(); });
    media.addEventListener('change', function () { paused = media.matches; renderMotion(); });
    renderMotion();
    const filters = document.querySelector('[data-product-filters]');
    const cards = Array.from(document.querySelectorAll('[data-product-kind]'));
    if (filters) {
      filters.hidden = false;
      filters.addEventListener('click', function (event) {
        const button = event.target.closest('[data-product-filter]');
        if (!button) return;
        const value = button.dataset.productFilter;
        filters.querySelectorAll('[data-product-filter]').forEach(function (item) { item.setAttribute('aria-pressed', String(item === button)); });
        cards.forEach(function (card) { card.hidden = value !== 'all' && card.dataset.productKind !== value; });
        const status = document.querySelector('[data-filter-status]');
        if (status) status.textContent = status.dataset.prefix + ' ' + button.textContent.trim();
      });
    }
    const links = Array.from(document.querySelectorAll('.nav a[href^="#"]'));
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function () {
        const active = links.find(function (link) {
          const target = document.querySelector(link.getAttribute('href'));
          if (!target) return false;
          const bounds = target.getBoundingClientRect();
          return bounds.top < window.innerHeight * 0.55 && bounds.bottom > window.innerHeight * 0.18;
        });
        links.forEach(function (link) {
          if (link === active) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      }, { rootMargin: '-18% 0px -45% 0px' });
      links.forEach(function (link) { const target = document.querySelector(link.getAttribute('href')); if (target) observer.observe(target); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();
(function () {
  'use strict';
  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-privacy-preferences]');
    if (!button) return;
    const status = document.querySelector('[data-privacy-status]');
    if (status) status.textContent = '';
    button.disabled = true;
    try {
      if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') throw new Error('Banner unavailable');
      await window.privacyBanner.showPreferences();
    } catch (_) {
      if (status) status.textContent = status.dataset.error;
    } finally {
      button.disabled = false;
    }
  });
})();
